import React from "react";
import classNames from "classnames";
import { useTranslation } from "react-i18next";

import { Props } from "./types";
import { SelectList } from "./selectList";
import styles from "./styles.scss";

function AccountForm({ formData, error, editForm }: Props) {
  const { t } = useTranslation();
  const titles = [
    { uuid: "c_level_svp_director", name: t("jobTitles.director") },
    { uuid: "manager", name: t("jobTitles.manager") },
    { uuid: "individual_contributor", name: t("jobTitles.contributor") },
    { uuid: "student_intern", name: t("jobTitles.intern") },
    { uuid: "other", name: t("jobTitles.other") },
  ];

  return (
    <div className={styles.form}>
      <div className={styles.group}>
        <h3 className={styles.label}>
          {t("accountCreationConfirmation.usernameTitle")}*
        </h3>
        <input
          value={formData.username}
          placeholder={t("accountCreationConfirmation.usernamePlaceholder")}
          className={classNames(styles.input, {
            [styles.invalidInput]: error.isAccountInvalid.isUsernameInvalid,
          })}
          onChange={({ target }) =>
            editForm({
              ...formData,
              username: target.value,
            })
          }
        />
      </div>
      <div className={styles.row}>
        <div className={styles.group}>
          <h3 className={styles.label}>
            {t("accountCreationConfirmation.passwordTitle")}*
          </h3>
          <input
            value={formData.password}
            type="password"
            placeholder={t("accountCreationConfirmation.passwordPlaceholder")}
            className={classNames(styles.input, {
              [styles.invalidInput]: error.isAccountInvalid.isPasswordInvalid,
            })}
            onChange={({ target }) =>
              editForm({
                ...formData,
                password: target.value,
              })
            }
          />
        </div>
        <div className={styles.group}>
          <h3 className={styles.label}>
            {t("accountCreationConfirmation.passwordConfirmationTitle")}*
          </h3>
          <input
            value={formData.passwordConfirmation}
            type="password"
            placeholder={t(
              "accountCreationConfirmation.passwordConfirmationPlaceholder",
            )}
            className={classNames(styles.input, {
              [styles.invalidInput]:
                error.isAccountInvalid.isPasswordConfirmationInvalid,
            })}
            onChange={({ target }) =>
              editForm({
                ...formData,
                passwordConfirmation: target.value,
              })
            }
          />
        </div>
      </div>
      <div className={styles.group}>
        <h3 className={styles.label}>
          {t("accountCreationConfirmation.companyTitle")}*
        </h3>
        <input
          value={formData.companyName}
          placeholder={t("accountCreationConfirmation.companyPlaceholder")}
          className={classNames(styles.input, {
            [styles.invalidInput]: error.isAccountInvalid.isCompanyInvalid,
          })}
          onChange={({ target }) =>
            editForm({
              ...formData,
              companyName: target.value,
            })
          }
        />
      </div>
      <div className={styles.group}>
        <h3 className={styles.label}>
          {t("accountCreationConfirmation.titleTitle")}
        </h3>
        <SelectList
          placeholder={t("accountCreationConfirmation.titlePlaceholder")}
          items={titles}
          selectedItem={
            titles.find(({ uuid }) => formData.title === uuid) || null
          }
          select={({ uuid }) => editForm({ ...formData, title: uuid })}
        />
      </div>
      <div className={styles.group}>
        <h3 className={styles.label}>
          {t("accountCreationConfirmation.addressTitle")}
        </h3>
        <input
          value={formData.address}
          placeholder={t("accountCreationConfirmation.addressPlaceholder")}
          className={classNames(styles.input, {
            [styles.invalidInput]: error.isAccountInvalid.isAddressMissing,
          })}
          onChange={({ target }) =>
            editForm({
              ...formData,
              address: target.value,
            })
          }
        />
      </div>
    </div>
  );
}

export { AccountForm };
